import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-bone/10 bg-obsidian px-6 py-16 text-bone md:px-12 lg:px-20">
      <div className="mx-auto max-w-[1400px]">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4">
              <img src="/brand/logo-hunar.png" alt="Hunar Designs" className="h-14 w-14 rounded-full object-cover ring-1 ring-bone/20" />
              <p className="font-serif text-4xl font-light tracking-tight md:text-5xl">
                Hunar <span className="italic">Designs</span>
              </p>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-bone/60">
              Fashion wear and home furnishing, crafted with hunar. Browse the collections and order directly on WhatsApp.
            </p>
          </div>
          <div className="md:col-span-4">
            <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-bone/50">Shop</p>
            <div className="mt-4 flex flex-col gap-3 text-sm">
              <Link data-testid="footer-link-fashion" to="/shop?section=fashion" className="text-bone/80 transition-colors hover:text-bone">Fashion Wear</Link>
              <Link data-testid="footer-link-furnishing" to="/shop?section=furnishing" className="text-bone/80 transition-colors hover:text-bone">Home Furnishing</Link>
              <Link data-testid="footer-link-mumkey" to="/mumkey" className="text-[#C98B93] transition-colors hover:text-bone">Mumkey — Maternity</Link>
              <Link data-testid="footer-link-about" to="/about" className="text-bone/80 transition-colors hover:text-bone">About Us</Link>
              <a
                data-testid="footer-link-instagram"
                href={process.env.REACT_APP_INSTAGRAM_URL || "https://instagram.com/hunardesigns"}
                target="_blank"
                rel="noopener noreferrer"
                className="text-bone/80 transition-colors hover:text-bone"
              >
                Instagram
              </a>
            </div>
          </div>
          <div className="md:col-span-3">
            <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-bone/50">Seller</p>
            <div className="mt-4 flex flex-col gap-3 text-sm">
              <Link data-testid="footer-link-seller-login" to="/auth" className="text-bone/80 transition-colors hover:text-bone">Seller Sign In</Link>
            </div>
          </div>
        </div>
        <div className="mt-14 flex flex-col gap-2 border-t border-bone/10 pt-6 text-xs text-bone/40 md:flex-row md:items-center md:justify-between">
          <p>© 2026 Hunar Designs. Crafted with care.</p>
          <p className="font-serif italic">Style for you. Style for home.</p>
        </div>
      </div>
    </footer>
  );
}
